import Modal from 'react-bootstrap/Modal';
import { useState,useEffect } from 'react';
/**
* In this file contain the parent analytic history details in table ui screen
**/
import ApiService from './../../services/ApiService';
import Pagination from './../components/Pagination';
import { convertUTCtoLocal } from './../../services/UtilsService';
import { useTranslation } from 'react-i18next';

function AnalyticsModal({data,handleClose}){

	//Variable declaration
	const [list,setList]=useState([]);
	const [params,setParams]=useState({page:0,limit:10,id:data.id});
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();
	//It call when component initialize
	useEffect(()=>{
		(async()=>{
			var response = await ApiService.listAnalytics(params);
			if(response.status===200)
				setList(response.data);
		})();
	},[params]);
	
	/** 
	* To handle pagination event
	* @data we get the user selected page number
	**/
	  const handlePaginate=(data)=>{  
		  setParams({...params,page:data});
	  };
	  
	return(
	     <Modal 
			show={data.show} 
			onHide={handleClose}  
			backdrop="static"
			keyboard={false}
			size="xl"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		  >
		  <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
			<Modal.Title>{t('modal.analyticsHistory')}</Modal.Title>
		  </Modal.Header>
		  <Modal.Body>
		    <div className="row my-3">
				<div className="col-xxl-12" >
                {/*Table Start*/}
					<div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`} style={{maxHeight:'500px'}}>	
						<table className="table table-borderless theme-table table-word-break">
							<thead>
							  <tr>
								<th role="row">{t('modal.memberName')}</th>
								<th role="row">{t('modal.physicianName')}</th>
								<th role="row">{t('landing.hospital')}</th>
								<th role="row">{t('modal.date')}</th>
								<th role="row">{t('modal.startTime')}</th>
								<th role="row">{t('modal.endTime')}</th>
								<th role="row">{t('modal.module')}</th>
								<th role="row">{t('modal.duration')}</th>
								<th role="row">{t('modal.platform')}</th>
								<th role="row">{t('modal.device')}</th>
								<th role="row">{t('modal.browser')}</th>
								<th role="row">{t('modal.browserVersion')}</th>
							  </tr>
							</thead>
							<tbody>
							{list?.items && list.items.length !==0 && list.items.map((item,i)=>(
							<tr className="text-capitalize" key={i}>
							 <td>{item.member_name?item.member_name:'--'}</td>
							 <td>{item.physician_name !== " " ?item.physician_name:'--'}</td>
							 <td>{item.hospital_admin_name !== " " ?item.hospital_admin_name:'--'}</td>
							 <td>{item.screenStartTime?convertUTCtoLocal(item.screenStartTime):'--'}</td>
							 <td>{item.screenStartTime?new Date(item.screenStartTime).toLocaleTimeString():'--'}</td>
							 <td>{item.screenEndTime?new Date(item.screenEndTime).toLocaleTimeString():'--'}</td>
							 <td>{item.module?item.module:'--'}</td>
							 <td>{item.duration?item.duration:'--'}</td>
							 <td>{item.appPlatform?item.appPlatform:'--'}</td>
							 <td>{item.deviceType?item.deviceType:'--'}</td>
							 <td>{item.webBrowserType?item.webBrowserType:'--'}</td>
							 <td>{item.webBrowserVersion?item.webBrowserVersion:'--'}</td>
							</tr>))}
							{list?.count && list.count ==='0' && <tr><td colSpan="12" className="text-center">No record found</td></tr>}
							</tbody>
						</table>
					</div>
				</div>
				{/*Table End*/}

				{/*Pagination */}
				{list?.items && list.items.length !==0 &&			
				<div className="col-xxl-12 my-3 d-flex justify-content-center">
					<Pagination page={params.page} handlePaginate={handlePaginate} total={list.count}  />
				</div>}
				{/*End Pagination */}
			</div>
		   </Modal.Body>
	    </Modal>
	);
};

export default AnalyticsModal;